<script setup lang="ts">
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTrigger,
} from '@/components/ui/sheet'
import {
  Button,
} from '@/components/ui/button'
const ShareBody = defineAsyncComponent(() => import('./ShareSheetContent/index.vue'))
const [open, toggle] = useToggle()
</script>

<template>
  <Sheet :open="open" modal @update:open="toggle">
    <SheetTrigger as-child>
      <slot />
    </SheetTrigger>
    <SheetContent side="right" class="top-0">
      <SheetHeader>
        <div class="flex items-center justify-between">
          <Heading level="4">
            Share it with the world!
          </Heading>
          <SheetClose as-child>
            <Button size="sm" variant="snack-cta">
              Done
            </Button>
          </SheetClose>
        </div>
        <SheetDescription>
          <p class="text-xs font-500 font-inter text-darkGray">
            Use our tool to create a beautiful visual for this prompt
            and
            share with
            everyone
          </p>
        </SheetDescription>
      </SheetHeader>

      <ShareBody v-if="open" />
    </SheetContent>
  </Sheet>
</template>
